import { useEffect, useState } from 'react'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons'
import { AuthServices } from '../util/authServices';

const Resumen = ({ setUserSession, setViewAdminZone, userSession, setCargando, toast }) => {

    const [scortReportObjectList, setScortReportObjectList] = useState([])

    useEffect(() => {
        obtieneListaReportScorts()
    }, [])

    const closeSession = () => {
        setUserSession({
            nombre: "",
            apellido: "",
            usuario: "",
            role: "USUARIO_LOGIN"
        })
        sessionStorage.removeItem('userSessionStorage')
    }

    const actionNavigate = (action) => {
        setViewAdminZone(action)
    }

    const detailsReport = (listDetails) => {
        const objetDetail = listDetails.map((detail) => {
            return (
                <>
                    <div className="row m-0">
                        <div className="col-4 col-sm-4 col-md-4 col-lg-4 p-label-report-response" >
                            {detail.fechaOn}
                        </div>
                        <div className="col-4 col-sm-4 col-md-4 col-lg-4 p-label-report-response" >
                            {detail.fechaOff}
                        </div>
                        <div className="col-4 col-sm-4 col-md-4 col-lg-4 p-label-report-response" >
                            {detail.duracionDisponible}
                        </div>
                    </div>
                    <hr className='hr-report-2' />
                </>
            )
        })
        return (
            <div className="div-detail-hijo">
                <div className="row m-0">
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 m-0" >
                        <p className='p-label-report-2'>Fecha On</p>
                    </div>
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 " >
                        <p className='p-label-report-2'>Fecha Off</p>
                    </div>
                    <div className="col-4 col-sm-4 col-md-4 col-lg-4 " >
                        <p className='p-label-report-2'>Duración</p>
                    </div>
                </div>
                <hr className='hr-report-2' />
                {objetDetail}
            </div>
        )
    }

    const actioDetailsReport = (scortReportObjet) => {
        setScortReportObjectList(scortReportObjectList.map((objectReporDetail) => {
            if (scortReportObjet === objectReporDetail) {
                objectReporDetail.classDetails = !objectReporDetail.classDetails
            }
            return objectReporDetail
        }))
    }

    const obtieneListaReportScorts = async () => {
        setCargando(true)
        const authServices = new AuthServices();
        try {
            const body = {
                "dateCurren": new Date(),
            }
            const response = await authServices.requestPost(body, 3);
            const { estado, mensaje, objeto } = response.data;
            if (estado) {
                setScortReportObjectList(objeto)
            } else {
                toast(mensaje)
            }
            setCargando(false);
        } catch (error) {
            setCargando(false);
            toast("Error de comunicación")
        }
    }

    return (
        <>
            <div className='div-container'>
                <div className="row m-0">
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6" >
                        <div className='div-name-user'>
                            <p>{`${userSession.nombre} ${userSession.apellido}`}</p>
                        </div>
                    </div>
                    <div className="col-6 col-sm-6 col-md-6 col-lg-6 control-margin" >
                        <div className='div-close-info' style={{ height: "3rem" }}>
                            <button className='btn btn-link btn-close-modal' onClick={() => actionNavigate('HOME')} >Volver a menú</button>
                            <button className='btn btn-link btn-close-modal' onClick={() => closeSession()} >Cerrar</button>
                        </div>
                    </div>
                </div>
                <hr className='hr-report' />
            </div>
            <div className='div-container' >
                <div className="row m-0">
                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 ">
                        <p className='p-label-report'>Identificación</p>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 " >
                        <p className='p-label-report'>Nombre</p>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 " >
                        <p className='p-label-report'>Nombre Artistico</p>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 col-lg-3 " >
                        <p className='p-label-report'>Disponibilidad</p>
                    </div>
                    <div className="col-12 col-sm-6 col-md-3 col-lg-3 " >
                        <p className='p-label-report'>Detalles</p>
                    </div>
                </div>
                {
                    scortReportObjectList?.map((scortReportObjet) => {
                        return (
                            <>
                                <div className="row m-0">
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 div-report-data" >
                                        {scortReportObjet.documento}
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 div-report-data" >
                                        {scortReportObjet.nombre}
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-2 div-report-data" >
                                        {scortReportObjet.nombreArtistico}
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-3 div-report-data" >
                                        {scortReportObjet.duracionTotal}
                                    </div>
                                    <div className="col-12 col-sm-6 col-md-3 col-lg-3 div-report-data" >
                                        <button className='btn btn-link' onClick={() => actioDetailsReport(scortReportObjet)}>
                                            {
                                                scortReportObjet.classDetails ?
                                                    <FontAwesomeIcon className='icon-eye-report' icon={faEyeSlash} />
                                                    :
                                                    <FontAwesomeIcon className='icon-eye-report' icon={faEye} />
                                            }
                                        </button>
                                    </div>
                                </div>
                                <div className={scortReportObjet.classDetails ? "div-details-report-active" : "div-details-report"}>
                                    {
                                        detailsReport(scortReportObjet.scortReportDetail)
                                    }
                                </div>
                                <hr className='hr-report' />
                            </>
                        )
                    })
                }
            </div>           
        </>
    )
}

export default Resumen